var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoSymbolWatermark = function SvgLogoSymbolWatermark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 384.759,
    height: 384.766,
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#074f4f",
    "data-name": "Group 1202",
    opacity: 0.934
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.544 139.923h-.5a90.42 90.42 0 0 1-90.189-90.2v-.48a49.455 49.455 0 1 0-49.67 49.677h.5a90.42 90.42 0 0 1 90.189 90.2v.5a49.442 49.442 0 1 0 49.67-49.7Z",
    "data-name": "Path 8562",
    opacity: 0.067
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.39 143.696h-.518a90.435 90.435 0 0 1-90.178-90.176v-.518a49.449 49.449 0 1 0-49.665 49.7 3.5 3.5 0 0 0 .516 0 90.435 90.435 0 0 1 90.167 90.194v.514a49.45 49.45 0 1 0 49.7-49.71h-.518",
    "data-name": "Path 8563",
    opacity: 0.067
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.579 285.845h-.5a90.42 90.42 0 0 1-90.189-90.2v-.5a49.443 49.443 0 1 0-49.67 49.706h.5a90.42 90.42 0 0 1 90.189 90.19v.514a49.451 49.451 0 1 0 49.7-49.706h-.5",
    "data-name": "Path 8564",
    opacity: 0.067
  }))));
};
export default SvgLogoSymbolWatermark;